// extracted by mini-css-extract-plugin
module.exports = {"exception":"Exception_exception__246og","logo":"Exception_logo__2NJRi","content":"Exception_content__Vje7i","title":"Exception_title__1QY9c","action":"Exception_action__aeUA4"};